import type { EmployeeRequestType } from "@/types/domain";

export interface RequestTypeDef {
  value: EmployeeRequestType;
  label: string;
  category: "Profile Changes" | "Attendance" | "Certificates & Services";
}

export const REQUEST_TYPES: RequestTypeDef[] = [
  { value: "address_change", label: "Address Change", category: "Profile Changes" },
  { value: "phone_change", label: "Phone Number Change", category: "Profile Changes" },
  { value: "email_change", label: "Email Change", category: "Profile Changes" },
  { value: "emergency_contact_change", label: "Emergency Contact Change", category: "Profile Changes" },
  { value: "bank_change", label: "Bank Details Change", category: "Profile Changes" },
  { value: "tax_change", label: "Tax / PAN Details Change", category: "Profile Changes" },
  { value: "attendance_correction", label: "Attendance Correction", category: "Attendance" },
  { value: "short_permission", label: "Short Leave / Permission (a few hours)", category: "Attendance" },
  { value: "comp_off", label: "Comp-off for working a weekly off / holiday", category: "Attendance" },
  { value: "employment_certificate", label: "Employment Certificate", category: "Certificates & Services" },
  { value: "salary_certificate", label: "Salary Certificate", category: "Certificates & Services" },
  { value: "experience_letter", label: "Experience Letter", category: "Certificates & Services" },
  { value: "id_card", label: "ID Card Request", category: "Certificates & Services" },
  { value: "asset_request", label: "Asset Request", category: "Certificates & Services" },
  { value: "document_request", label: "Document Request", category: "Certificates & Services" },
  { value: "hr_service_request", label: "General HR Service Request", category: "Certificates & Services" },
];

export const REQUEST_TYPE_LABEL: Record<EmployeeRequestType, string> = Object.fromEntries(
  REQUEST_TYPES.map((t) => [t.value, t.label]),
) as Record<EmployeeRequestType, string>;

// Mirrors domain.profileFields exactly (backend/internal/service/employee_request.go) -
// which JSON keys a profile-change request type may carry, and their labels.
export const PROFILE_FIELDS: Partial<Record<EmployeeRequestType, { key: string; label: string; employeeField: string }[]>> = {
  address_change: [{ key: "address", label: "Address", employeeField: "address" }],
  phone_change: [{ key: "phone", label: "Phone", employeeField: "phone" }],
  email_change: [{ key: "email", label: "Email", employeeField: "email" }],
  emergency_contact_change: [
    { key: "emergency_contact_name", label: "Emergency contact name", employeeField: "emergency_contact_name" },
    { key: "emergency_contact_phone", label: "Emergency contact phone", employeeField: "emergency_contact_phone" },
    { key: "emergency_contact_relation", label: "Relationship", employeeField: "emergency_contact_relation" },
  ],
  bank_change: [
    { key: "bank_name", label: "Bank name", employeeField: "bank_name" },
    { key: "bank_branch", label: "Branch", employeeField: "bank_branch" },
    { key: "bank_account_number", label: "Account number", employeeField: "bank_account_number" },
    { key: "bank_ifsc", label: "IFSC code", employeeField: "bank_ifsc" },
  ],
  tax_change: [
    { key: "pan_number", label: "PAN number", employeeField: "pan_number" },
    { key: "aadhaar_number", label: "Aadhaar number", employeeField: "aadhaar_number" },
  ],
};
